import { styled } from '@mui/material/styles';
import { default as LinkComponent } from 'components/Link';

const menuItemSize = 200;

export const MenuContainer = styled('div')(({ theme, selectedIndex }) => ({
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  position: 'relative',
  marginTop: theme.spacing(5),
  marginBottom: theme.spacing(5),
  alignItems: 'flex-start',
  '&:after': {
    content: '""',
    position: 'absolute',
    borderBottom: '3px solid #206AF5',
    width: `${menuItemSize}px`,
    bottom: theme.spacing(-2),
    display: 'block',
    left: '0px',
    transitionDuration: '0.3s',
    transform: `translate(${menuItemSize * selectedIndex}px,0)`
  }
}));

export const Link = styled(LinkComponent)(({ theme, selected }) => ({
  alignItems: 'center',
  color: selected ? '#206AF5' : '#666666',
  display: 'inline-flex',
  ...(selected && {
    fontWeight: theme.fontWeight.bold
  }),
  height: '100%',
  lineHeight: '100%',
  position: 'relative',
  width: `${menuItemSize}px`,
  justifyContent: 'center'
}));
